import axios from "axios";
import { msalInstance, silentRequest } from "../auth/msalConfig";

const api = axios.create({
    baseURL: process.env.REACT_APP_BASEAPIURL
})

api.interceptors.request.use(async (config) => {
    try {
        const accounts = await msalInstance.getAllAccounts();
        if (accounts.length === 0) throw new Error("No accounts found")

        const response = await msalInstance.acquireTokenSilent({
            ...silentRequest,
            account: accounts[0]
        })
        const idToken = response.idToken

        if (idToken) {
            config.headers.Authorization = `Bearer ${idToken}`
        }
        return config;
    }
    catch (error) {
        return Promise.reject(error)
    }


}, (error) => Promise.reject(error))

api.interceptors.response.use(
    (reponse) => reponse,
    async (error) => {
        if (error.response?.status === 401) {
            return Promise.reject(error)
        }
        else {
            return Promise.reject(error)
        }

    }
)

export default api;